import { Partner, PartnerState } from './types';
import { ReduxAction, setAsyncData } from '../../core';

import { PartnerActions } from './actions';

const initialState: PartnerState = {
  partners: { isFetching: false },
};

export function partnerReducer(state: PartnerState = initialState, action: ReduxAction<any>): PartnerState {
  switch (action.type) {
    case PartnerActions.SET_PARTNERS_IS_FETCHING:
      return {
        ...state,
        partners: setAsyncData(state.partners, (v) => (v.isFetching = action.data)),
      };
    case PartnerActions.SET_PARTNERS:
      return {
        ...state,
        partners: setAsyncData(state.partners, (v) => {
          v.data = action.data as Partner[];
          v.error = '';
        }),
      };
    case PartnerActions.SET_PARTNERS_ERROR:
      return {
        ...state,
        partners: setAsyncData(state.partners, (v) => (v.error = action.data)),
      };
    default:
      return state;
  }
}
